import { render } from "./ThanksDetail.vue?vue&type=template&id=f87beaf4"
import script from "./ThanksDetail.vue?vue&type=script&lang=js"
export * from "./ThanksDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__